module.exports = {
  GalleryData: () => {
    return {

      "mg_zs_hybrid_2025" : 
        [
          // {
          //   "id": "mg_zs_hybrid_2025-1",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-6.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-2",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-10.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-3",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-17.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-4",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-27.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-5",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-59.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-6",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-61.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-7",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-89.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-8",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-111.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-9",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-138.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-10",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG_ZS_Hybrid-143.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-11",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG-ZS-2024-012.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-12",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG-ZS-2024-014.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-13",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG-ZS-2024-016.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-14",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG-ZS-2024-026.webp"),
          //   "active" : true
          // },
          // {
          //   "id": "mg_zs_hybrid_2025-15",
          //   "name" : "",
          //   "desc" : "",
          //   "image": require("../assets/images/mg_zs_hybrid_2025/MG-ZS-2024-036.webp"),
          //   "active" : true
          // },
          
          {
            "id": "mg_zs_hybrid_2025-001",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/001.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-002",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/002.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-003",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/003.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-004",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/004.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-005",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/005.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-006",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/006.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-007",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/007.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-008",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/008.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-009",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/009.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-010",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/010.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-011",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/011.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-012",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/012.webp"),
            "active" : true
          },
          {
            "id": "mg_zs_hybrid_2025-013",
            "name" : "",
            "desc" : "",
            "image": require("../assets/images/mg_zs_hybrid_2025/013.webp"),
            "active" : true
          },
        ],
      
    }
  }
}